import styled from 'styled-components';

export const CTAButtonGroupHeaderWrapper = styled('div')`
  width: 100%;
  text-align: center;
  margin-bottom: 30px;
`;
